<template>
    <div>
        <v-icon small v-if="item[header.value] === 'like'" color="success">mdi-thumb-up-outline</v-icon>
        <v-icon small v-else color="error">mdi-thumb-down-outline</v-icon>
    </div>
</template>

<script setup>

import { defineProps } from 'vue'

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})

</script>